import React from 'react'
import { IUser } from '@/model/types/user'
import { ColumnsType } from 'antd/lib/table'
import { Row } from '@/components/layout/layout'
import { $post } from '@/api'
import { useRequest } from 'ahooks'
import { IPagination } from '@/model/types/common'
import $msg from '@/utils/message'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import { Table } from 'antd'
import { observer } from 'mobx-react'
import { staffListModel } from '../model'

import './staff-list-table.scss'
import { getBEMCls } from '@/utils/classname'
import { showLayer } from '@/utils/layer'
import StaffDetail from '../staff-detail/staff-detail'
import SuperAdmin from '@/assets/images/super-admin.svg'
import EditStaff from '../edit-staff/edit-staff'
import Auth from '@/views/main/components/auth/auth'
import { shopStore } from '@/store/shop'

export interface StaffList {
    id: number
    shop: number
    status: number
    permission_list: number[]
    creator_name: string
    position: string
    entry_date: string
    remarks: string
    user: IUser
    permission_source_staff: {
        id?: number
        remarks?: string
        user?: IUser
    }
}

const StaffListTable = observer(() => {
    const cls = (...arg: string[]) => getBEMCls('staff-list-table', ...arg)

    const columns: ColumnsType<StaffList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '姓名',
            key: 'name',
            render: (val, record) => {
                return (
                    <Row data-align-items-center>
                        <img
                            style={{
                                border: `1px solid ${record.user.gender === 2 ? '#ee5b5b' : '#3c90ff'}`,
                            }}
                            className={cls('avatar')}
                            src={record.user.avatar}
                            alt=""
                        />
                        <div className={cls('nickname')}>{record.user.nickname}</div>
                        <div className={cls('realname')}>({record.user.realname})</div>
                        {shopStore.shopInfo?.creator.id === record.user.id && (
                            <img data-width-86 data-height-16 data-margin-left-8 src={SuperAdmin} alt="" />
                        )}
                    </Row>
                )
            },
        },
        {
            title: '手机号码',
            key: 'phone',
            render: (val, record) => record.user.phone,
        },
        {
            title: '操作',
            key: 'is_draft',
            width: 110,
            align: 'center',
            render: (val, record) => (
                <>
                    <div
                        className="action"
                        onClick={() => {
                            showLayer(<StaffDetail staffId={record.id} refresh={requestHandle.refresh} />)
                        }}
                    >
                        详情
                    </div>
                    <Auth
                        perssion={46}
                        onClick={() => {
                            showLayer(<EditStaff staffId={record.id} />)
                        }}
                    >
                        <div
                            className="action"
                            style={{
                                marginLeft: '18px',
                            }}
                        >
                            编辑
                        </div>
                    </Auth>
                </>
            ),
        },
    ]

    const requestHandle = useRequest<
        {
            list: StaffList[]
            pagination: IPagination
            maxStaffNumber: number
            staffCount: number
        },
        {
            staff_list: StaffList[]
            pagination: IPagination
            max_staff_number: number
            staff_count: number
        }
    >(
        val => {
            return $post({
                url: '/staff/getstafflist',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    status: 0,
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            onSuccess: res => {
                staffListModel.setStaffNum(res.staffCount)
                staffListModel.setMaxStaffNum(res.maxStaffNumber)
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.staff_list,
                    pagination: data.pagination,
                    maxStaffNumber: data.max_staff_number || 0,
                    staffCount: data.staff_count || data.staff_list.length,
                }
            },
            onError: e => {
                $msg('error', e.message)
            },
        },
    )

    return (
        <div className="table-container">
            <AutoResizer>
                {({ height }) => {
                    return (
                        <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                            <Table
                                rowKey={record => record.id}
                                loading={requestHandle.loading || requestHandle.loadingMore || void 0}
                                bordered
                                pagination={false}
                                columns={columns}
                                dataSource={requestHandle.data?.list}
                                scroll={{ x: 'max-content', y: height - 50 }}
                            />
                        </WithScrollLoad>
                    )
                }}
            </AutoResizer>
        </div>
    )
})

export default StaffListTable
